export const emceeAppRoute = {
	name: 'global-settings-addons-emcee',
	path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page',
};
export const manageAppsRoute = {
	name: 'global-settings-addons-upm',
	path: '/plugins/servlet/upm',
};
